import React from 'react';
import PillButton from '../PillButton/PillButton';
import './EmptyState.css';

export interface EmptyStateAction {
  label: string;
  to?: string;
  onClick?: () => void;
}

export interface EmptyStateProps {
  title: string;
  /** At most one sentence. */
  message?: string;
  action?: EmptyStateAction;
  headingLevel: 1 | 2;
  className?: string;
  id?: string;
  testId?: string;
}

/**
 * Honest emptiness: a heading, optionally one sentence and one real action.
 * No alert role, no illustration, no fabricated content.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ title, message, action, headingLevel, className, id, testId }) => {
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  return (
    <div id={id} className={`luma-empty${className ? ` ${className}` : ''}`} data-testid={testId}>
      <Heading className="luma-empty__title">{title}</Heading>
      {message && <p className="luma-empty__message">{message}</p>}
      {action && (
        <div className="luma-empty__action">
          {action.to ? (
            <PillButton variant="primary" to={action.to}>{action.label}</PillButton>
          ) : (
            <PillButton variant="primary" onClick={action.onClick}>{action.label}</PillButton>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
